/**
 * Intended for native iOS/Android callers outside React components and hooks, not RN Web.
 * React callers should use useJSTModel(). This convention is not enforced at runtime.
 */
import { normalizeEnvironment } from "../../internal/environment/normalizeEnvironment";
import type { TareBridge } from "../../internal/NativeModulesTypes";
import type { JSTModel } from "../../model/JSTModel.types";

/** Returns lazy model reads for a host that runs outside React. */
export function getJSTModelSync(getBridge: () => TareBridge | undefined): JSTModel {
  return {
    user: {
      get accountStatus() {
        return getBridge()?.getAccountStatusSync?.() ?? null;
      },
    },
    get app() {
      const app = getBridge()?.getAppModelSync?.();
      return app
        ? {
            get appSessionInfo() {
              return getBridge()?.getAppSessionInfoSync?.() ?? null;
            },
            ...app,
            buildEnvironment: normalizeEnvironment(app.buildEnvironment),
          }
        : null;
    },
    get device() {
      return getBridge()?.getDeviceModelSync?.() ?? null;
    },
  };
}
